import { gql } from "@apollo/client";
export type ReferralProgramStatus = {
  userId: string;
  eligible: boolean;
  state: "NOT_ENROLLED" | "UNDER_REVIEW" | "APPROVED" | "REJECTED";
  appliedAt: string | null;
  joinedAt: string | null;
};
export const REFERRAL_PROGRAM = gql`
  query ReferralProgram {
    referralProgram {
      userId
      eligible
      state
      appliedAt
      joinedAt
    }
  }
`;
export const APPLY_TO_REFERRAL_PROGRAM = gql`
  mutation ApplyToReferralProgram {
    applyToReferralProgram {
      userId
      eligible
      state
      appliedAt
      joinedAt
    }
  }
`;
